"use client";
import LogRocket from "logrocket";
import { useEffect } from 'react';
import { useUser } from "@clerk/nextjs";
import { useOrganization } from "@clerk/nextjs";
import { initLogRocket } from '@/lib/logrocket';

const isProduction = process.env.NODE_ENV === 'production';

const useLogRocket = () => {
  const { user } = useUser();
  const { organization } = useOrganization();
  const isEnabled = isProduction && typeof window !== "undefined";

  useEffect(() => {
    if (isEnabled)
    initLogRocket();
  }, []);
  
  useEffect(() => {
    const email = user?.emailAddresses?.[0]?.emailAddress
    if (isEnabled && user && email) {
      LogRocket.identify(user.id, {
        name: user.fullName || 'Unknown',
        email,
        organization: organization?.name || 'Unknown',
      });
    }
  }, [user, organization])
}

export default useLogRocket;
